import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Switch, Route, useLocation, useRouteMatch } from 'react-router-dom';

import ViewTitle from '../../common/view-title';
import Loader from '../../common/loader';
import NotFound from '../../common/not-found';

import TicketLocationTransferMenu from './ticket-location-transfer-menu';
import TicketLocationTransferCreate from './ticket-location-transfer-create';
import TicketLocationTransferDetail from './ticket-location-transfer-detail';
import TicketLocationTransferIndex from './ticket-location-transfer-index';
import TicketLocationTransferReport from './ticket-location-transfer-report';

import helpers from '../../utils/helpers';

const useStyles = makeStyles(() => ({
    root: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
    }
}));

const TicketLocationTransfer = () => {

    const classes = useStyles();
    const { pathname } = useLocation();
    const { path } = useRouteMatch();
    const [state, setState] = useState({
        loading: true,
        permissions: {}
    });

    useEffect(() => {
        const validatePermissions = () => {
            const permissions = helpers.getPermissions(pathname);
            setState(prev => ({ ...prev, permissions, loading: false }));
        }

        validatePermissions();
    }, []);

    if (state.loading) {
        return <Loader />;
    }

    if (!state.permissions?.read_attr) {
        return <NotFound />;
    }

    return (
        <div className={classes.root}>
            <ViewTitle sedeFlag title='Ticket location transfer' />

            <Switch>
                <Route exact path={path}><TicketLocationTransferMenu permissions={state.permissions} /></Route>
                <Route exact path={`${path}/report`}><TicketLocationTransferReport permissions={state.permissions} /></Route>
                <Route exact path={`${path}/create`}><TicketLocationTransferCreate permissions={state.permissions} /></Route>
                <Route exact path={`${path}/index`}><TicketLocationTransferIndex permissions={state.permissions} /></Route>
                <Route exact path={`${path}/:id`}><TicketLocationTransferDetail permissions={state.permissions} /></Route>
                <Route path={`${path}/*`}><NotFound /></Route>
            </Switch>
        </div>
    );
}

export default TicketLocationTransfer;